export default __webpack_public_path__ + "static/media/service03.3bf0fccf.svg";